import { render } from "./TestUCSearchEntityERP.vue?vue&type=template&id=e8b38230"
import script from "./TestUCSearchEntityERP.vue?vue&type=script&lang=js"
export * from "./TestUCSearchEntityERP.vue?vue&type=script&lang=js"

import "./TestUCSearchEntityERP.vue?vue&type=style&index=0&id=e8b38230&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__